<template>
  <div>
    <Base :satisfied="requirement.satisfied" icon="mdi-briefcase" tooltip>
      <span>
        Work rights
      </span>
      <span slot="tooltip">
        {{ first ? 'The ideal candidate' : 'and' }}
        {{ requirement.mandatory ? 'must' : 'could' }}
        {{ requirement.negative ? 'not' : '' }}
        have work rights in {{ requirement.country.name }}
      </span>
    </Base>
  </div>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Vue Component
export default {
  components: { Base },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
  },
}
</script>
